import { observable } from "mobx";
import CabotagemService from "../../../../services/CabotagemService";
import React from "react";
import {montarSelectOption} from "../../../../utils/formatar";

export default class FiltrosCabotagemStore {

    @observable situacoesFiltros;

    @observable filtroNavio;
    @observable filtroSituacao;
    @observable filtros;

    constructor() {
        this.situacoesFiltros = false;

        this.filtroNavio = false;
        this.filtroSituacao = false;
        this.filtros = {
            cte: null, cntr: null, chave: null
        };

        this.service = new CabotagemService();

        this.carregarFiltros();
    };

    carregarFiltros = () => {
        this.service.listarSituacoes().then(response => {
            if (response.data) {
                this.situacoesFiltros = montarSelectOption("Codigo", "Descr", response.data);
            }
        });
    };

    onChangeFiltro = (dado, event) => {
        if (event) {
            _.set(this.filtros, dado, event.target.value);
        } else {
            _.set(this.filtros, dado, null);
        }
    };

    onChangeFiltroNavios = value => {
        this.filtroNavio = value!==null ? value : false;
    };

    onChangeFiltroSituacao = value => {
        this.filtroSituacao = value!==null ? value : false;
    };
}



// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/stores/FiltrosCabotagemStore.js